import(/* webpackMode: "eager" */ "/opt/build/repo/app/greeting/page.tsx");
